module.exports = __webpack_public_path__ + "media/images/emblems/Collombeymuraz-b97d89b7ecef2a51f7ee43dd657fe6af.png";